import {BasicProps} from "../Main";
import React, {useEffect, useState} from "react";
import {
	Grid,
	Collapse,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	MenuItem
} from "@mui/material";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {Colours, SamaggiTypography} from "../Components/SamaggiTypography";
import {SamaggiSelect} from "../Components/SamaggiFields";
import {SamaggiButton} from "../Components/SamaggiButton";
import axios from "axios";
import {handleError} from "../support";
import {useNavigate, useSearchParams} from "react-router-dom";
import {truncate} from "./Reimbursements";


export const PostixBankTransfer: React.FC<BasicProps> = (props) => {

	const [rows, setRows] = useState<Array<ReturnType<typeof createData>>>([]);

	const [sort, setSort] = useState("L");

	const [params, ] = useSearchParams();

	const navigate = useNavigate();

	function createData(
		id: string,
		name: string,
		phone: string,
		email: string,
		ticketType: string,
		quantity: number,
		totalPrice: number,
		status: string,
		slipURL: string,
		approvedPerson: string,
		approvedTime: number,
		time: number,
		notes: string,
		expired: boolean,
		currency: string
	) {
		return {
			id,
			name,
			phone,
			email,
			ticketType,
			quantity,
			totalPrice,
			status,
			slipURL,
			approvedPerson,
			approvedTime,
			time,
			notes,
			expired,
			currency
		};
	}

	function load() {
		const token = localStorage.getItem("token");

		props.setShowCover(true);

		axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/postix/list", {"token": token}).then((res) => {
			console.log(res);
			props.setShowCover(false);

			const data: Array<ReturnType<typeof createData>> = [];

			res.data.data.data.forEach((item: any) => {
				data.push(
					createData(
						item["session_id"],
						item["billingName"],
						item["phone"],
						item["email"],
						item["type"],
						item["quantity"],
						item["price"],
						item["status"],
						item["slip"],
						item["approved-person"],
						item["approved-time"],
						item["time"],
						item["notes"],
						item["expired"],
						item["currency"]
					)
				)
			})

			setRows(data);
		}).catch((error) => {
			props.setShowCover(false);
			alert("Unable to load data.");

			handleError(error, true);
		})
	}

	useEffect(() => {
		load() // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])


	function action(approve: boolean, requestID: string) {
		const token = localStorage.getItem("token");

		props.setShowCover(true);

		const data = {
			"token": token,
			"approved": approve,
			"sessionID": requestID
		}

		axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/postix/mark", data).then((res) => {
			console.log(res);
			alert("Updated Successfully");
			load();
		}).catch((error) => {
			props.setShowCover(false);

			handleError(error, true);
		})
	}

	function Row(props: { row: ReturnType<typeof createData> }) {
		const { row } = props;
		const [open, setOpen] = useState(row.id === params.get("finreq"));

		return (
			<React.Fragment>
				<TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
					<TableCell sx={{padding: 0}}>
						<IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
							{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
						</IconButton>
					</TableCell>
					<TableCell sx={{padding: 0}} align={"center"}>{row.ticketType}</TableCell>
					<TableCell sx={{padding: 0}} align={"center"}>{truncate(row.name)}</TableCell>
					<TableCell sx={{padding: 0}} align={"center"}>{row.currency} {row.totalPrice}</TableCell>
					<TableCell align={"center"} sx={{padding: 0}}>{row.status}</TableCell>
				</TableRow>
				<TableRow>
					<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
						<Collapse in={open} timeout="auto" unmountOnExit sx={{paddingLeft: 0, paddingRight: 0, paddingTop: 5, paddingBottom: 5}}>
							<Grid container direction={"column"} spacing={4}>
								<Grid item container direction={"column"} spacing={1.2}>
									<Grid item>
										<SamaggiTypography large bold colour={Colours.samaggiOrange}>
											General
										</SamaggiTypography>
									</Grid>
									<Grid item>
										<SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>ID: </SamaggiTypography>{row.id}</SamaggiTypography>
									</Grid>
									<Grid item>
										<SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Name: </SamaggiTypography>{row.name}</SamaggiTypography>
									</Grid>
									<Grid item>
										<SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Ticket Type: </SamaggiTypography>{row.ticketType}</SamaggiTypography>
									</Grid>
									<Grid item>
										<SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Amount Due: </SamaggiTypography>{row.currency} {row.totalPrice}</SamaggiTypography>
									</Grid>
									<Grid item>
										<SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Phone: </SamaggiTypography>{row.phone}</SamaggiTypography>
									</Grid>
									<Grid item>
										<SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Email: </SamaggiTypography>{row.email}</SamaggiTypography>
									</Grid>
									<Grid item>
										<SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Status: </SamaggiTypography>{row.status}</SamaggiTypography>
									</Grid>
									{row.notes !== "" && <Grid item>
										<SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Notes: </SamaggiTypography>{row.notes}</SamaggiTypography>
									</Grid>}
								</Grid>
								<Grid item container direction={"column"} spacing={1.2}>
									<Grid item>
										<SamaggiTypography large bold colour={Colours.samaggiOrange}>
											Files
										</SamaggiTypography>
									</Grid>
									{row.slipURL !== "" && <Grid item>
										<SamaggiButton fullWidth onClick={() => {window.open(row.slipURL, "_blank")}}>View Slip</SamaggiButton>
									</Grid>}
								</Grid>
								{(row.status === "Pending") && <Grid item container direction={"column"} spacing={1.2}>
									<>
										<Grid item>
											<SamaggiTypography large bold colour={Colours.samaggiOrange}>
												Actions
											</SamaggiTypography>
										</Grid>
										<Grid item>
											<SamaggiButton fullWidth colour={Colours.green} hoverColour={Colours.darkGreen} onClick={() => {action(true, row.id)}}>Approve</SamaggiButton>
										</Grid>
										<Grid item>
											<SamaggiButton fullWidth colour={Colours.red} hoverColour={Colours.darkRed} onClick={() => {action(false, row.id)}}>Reject</SamaggiButton>
										</Grid>
									</>
								</Grid>}
							</Grid>
						</Collapse>
					</TableCell>
				</TableRow>
			</React.Fragment>
		);
	}


	return (
		<Grid container direction={"column"} spacing={2}>
			<Grid item>
				<SamaggiSelect label={"Sort By"} value={sort} onChange={(e) => {setSort(e.target.value as string)}}>
					<MenuItem value={"L"}>Latest</MenuItem>
				</SamaggiSelect>
			</Grid>
			<Grid item>
				<TableContainer component={Paper}>
					<Table aria-label="collapsible table" size="small">
						<TableHead>
							<TableRow>
								<TableCell/>
								<TableCell align={"center"}>Ticket Type</TableCell>
								<TableCell align={"center"}>Name</TableCell>
								<TableCell align={"center"}>Amount</TableCell>
								<TableCell align={"center"}>Status</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{rows.sort((a,b) => b.time - a.time).map((row) => (
								<Row key={row.time} row={row} />
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Grid>
			<Grid item>
				<SamaggiButton fullWidth onClick={() => {props.setShowCover(true); load()}}>Reload</SamaggiButton>
			</Grid>
			<Grid item>
				<SamaggiButton fullWidth colour={Colours.gray} hoverColour={Colours.darkGray} onClick={() => {navigate("/")}}>Back to Staff Portal</SamaggiButton>
			</Grid>
		</Grid>
	);
}